"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTypeFilter = exports.setSelectedTaskID = exports.setTasks = exports.selectTaskByID = exports.selectTypeFilter = exports.selectSelectedTaskID = exports.selectCompletedTaskByBranchID = exports.selectAdhocTaskByBranchID = exports.selectDailyTaskByBranchID = exports.selectTasksByBranchID = exports.selectTasks = exports.toggleSubTask = exports.updateStatus = exports.deleteTask = exports.updateTask = exports.createTask = exports.taskSliceConfig = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var models_1 = require("@dayone/models");
var firestore_1 = require("firebase/firestore");
var moment_1 = __importDefault(require("moment"));
var storage_1 = require("firebase/storage");
var uuid_1 = require("uuid");
var common_1 = require("@dayone/common");
var firebase_1 = require("@dayone/firebase");
var firebaseApp;
var firestore;
var storage;
var taskSliceConfig = function (_firebaseApp) {
    firebaseApp = _firebaseApp;
    firestore = (0, firestore_1.getFirestore)(_firebaseApp);
    storage = (0, storage_1.getStorage)(_firebaseApp);
};
exports.taskSliceConfig = taskSliceConfig;
var initialState = {
    initialised: false,
    tasks: [],
    selectedTaskID: null,
    typeFilter: 'all',
};
// CRUD - Create, Read, Update, Delete
var convertImageUrlToBlob = function (images) { return __awaiter(void 0, void 0, void 0, function () {
    var isNotNull, blobs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isNotNull = function (_blob) { return !!_blob; };
                return [4 /*yield*/, Promise.all((images || []).map(function (image) { return __awaiter(void 0, void 0, void 0, function () {
                        var downloadUrl, request, response, blob;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!image.url) return [3 /*break*/, 4];
                                    return [4 /*yield*/, (0, storage_1.getDownloadURL)((0, storage_1.ref)(storage, image.url))];
                                case 1:
                                    downloadUrl = _a.sent();
                                    request = new Request(downloadUrl, { method: 'GET' });
                                    return [4 /*yield*/, fetch(request)];
                                case 2:
                                    response = _a.sent();
                                    return [4 /*yield*/, response.blob()];
                                case 3:
                                    blob = _a.sent();
                                    return [2 /*return*/, blob];
                                case 4: return [2 /*return*/, null];
                            }
                        });
                    }); }))];
            case 1:
                blobs = _a.sent();
                return [2 /*return*/, blobs.filter(isNotNull)];
        }
    });
}); };
exports.createTask = (0, toolkit_1.createAsyncThunk)('task/create', function (_a, thunkAPI) {
    var payload = _a.task, isCloning = _a.isCloning;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, uid, displayName, taskCollectionRef, data, taskDocRef, files, addedImages, blobs, addedImages;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    state = thunkAPI.getState();
                    uid = (_c = (_b = state.me.details) === null || _b === void 0 ? void 0 : _b.uid) !== null && _c !== void 0 ? _c : '';
                    displayName = (_d = state.me.account) === null || _d === void 0 ? void 0 : _d.displayName;
                    if (payload.subTaskItems && payload.subTaskItems.length) {
                        payload.subTaskItems.forEach(function (item) {
                            if (!item.id) {
                                item.id = (0, uuid_1.v4)();
                            }
                        });
                    }
                    taskCollectionRef = (0, firestore_1.collection)(firestore, 'companies', payload.companyID, 'tasks');
                    data = {
                        branchID: payload.branchID,
                        companyID: payload.companyID,
                        description: payload.description,
                        flag: payload.flag,
                        name: payload.name,
                        status: isCloning ? models_1.TaskStatus.open : payload.status,
                        taskCompletedAt: (payload === null || payload === void 0 ? void 0 : payload.taskCompletedAt) ? firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.taskCompletedAt).toDate()) : null,
                        type: payload.type,
                        subTaskCompleted: [],
                        subTaskItems: payload.subTaskItems.filter(function (t) { return t.content && t.content.length > 0; }),
                        user: [],
                        images: [],
                        completedBy: isCloning ? null : payload === null || payload === void 0 ? void 0 : payload.completedBy,
                        imageSubmission: payload.imageSubmission,
                        startDate: (payload === null || payload === void 0 ? void 0 : payload.startDate) ? firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.startDate).toDate()) : null,
                        endDate: (payload === null || payload === void 0 ? void 0 : payload.endDate) ? firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.endDate).toDate()) : null,
                        recurringDayOfWeek: payload === null || payload === void 0 ? void 0 : payload.recurringDayOfWeek,
                        recurringRepeat: payload === null || payload === void 0 ? void 0 : payload.recurringRepeat,
                        recurringType: payload === null || payload === void 0 ? void 0 : payload.recurringType,
                        occurrentDate: payload.flag === models_1.TaskFlag.urgent
                            ? firestore_1.Timestamp.fromDate(new Date())
                            : payload.type === models_1.TaskType.adHoc
                                ? firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.startDate).toDate())
                                : null,
                        nextOccurrent: payload.flag === models_1.TaskFlag.urgent
                            ? firestore_1.Timestamp.fromDate(new Date())
                            : firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.startDate).toDate()),
                        createdAt: firestore_1.Timestamp.now(),
                        createdBy: uid,
                        createdByDisplayName: displayName !== null && displayName !== void 0 ? displayName : '',
                        updatedAt: firestore_1.Timestamp.now(),
                        updatedBy: uid,
                        updatedByDisplayName: displayName !== null && displayName !== void 0 ? displayName : '',
                    };
                    return [4 /*yield*/, (0, firestore_1.addDoc)(taskCollectionRef, data)];
                case 1:
                    taskDocRef = _e.sent();
                    if (!!isCloning) return [3 /*break*/, 4];
                    files = payload.images.map(function (x) { return x.file; }).filter(function (x) { return !!x; });
                    return [4 /*yield*/, uploadImages(files, payload.companyID, taskDocRef.id)];
                case 2:
                    addedImages = _e.sent();
                    return [4 /*yield*/, (0, firestore_1.updateDoc)(taskDocRef, { images: addedImages })];
                case 3:
                    _e.sent();
                    return [3 /*break*/, 8];
                case 4: return [4 /*yield*/, convertImageUrlToBlob(payload.images)];
                case 5:
                    blobs = _e.sent();
                    return [4 /*yield*/, uploadImages(blobs, payload.companyID, taskDocRef.id)];
                case 6:
                    addedImages = _e.sent();
                    return [4 /*yield*/, (0, firestore_1.updateDoc)(taskDocRef, { images: addedImages })];
                case 7:
                    _e.sent();
                    _e.label = 8;
                case 8: return [2 /*return*/, taskDocRef];
            }
        });
    });
});
exports.updateTask = (0, toolkit_1.createAsyncThunk)('task/update', function (payload, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, uid, displayName, unchangeImages, toAddImages, files, addedImages, toDeleteImages, taskDocRef, data;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!(payload.companyID != null && payload.taskID !== null)) return [3 /*break*/, 4];
                state = thunkAPI.getState();
                uid = (_b = (_a = state.me.details) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : '';
                displayName = (_c = state.me.account) === null || _c === void 0 ? void 0 : _c.displayName;
                unchangeImages = payload.images.filter(function (img) { return img.action === 'UNCHANGE'; });
                toAddImages = payload.images.filter(function (img) { return img.action === 'ADD'; });
                files = toAddImages.map(function (x) { return x.file; }).filter(function (x) { return !!x; });
                return [4 /*yield*/, uploadImages(files, payload.companyID, payload.taskID)];
            case 1:
                addedImages = _d.sent();
                toDeleteImages = payload.images.filter(function (img) { return img.action === 'REMOVE'; });
                return [4 /*yield*/, deleteImageByDownloadUrl(toDeleteImages.map(function (x) { return x.url; }))];
            case 2:
                _d.sent();
                taskDocRef = (0, firestore_1.doc)(firestore, 'companies', payload.companyID, 'tasks', payload.taskID);
                data = {
                    branchID: payload.branchID,
                    description: payload.description,
                    flag: payload.flag,
                    status: payload.status,
                    taskCompletedAt: (payload === null || payload === void 0 ? void 0 : payload.taskCompletedAt) ? firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.taskCompletedAt).toDate()) : null,
                    images: unchangeImages.map(function (img) { return img.url || ''; }).concat(addedImages) || [],
                    name: payload.name,
                    type: payload.type,
                    subTaskItems: payload.subTaskItems.filter(function (t) { return t.content && t.content.length > 0; }),
                    completedBy: payload === null || payload === void 0 ? void 0 : payload.completedBy,
                    imageSubmission: payload.imageSubmission,
                    startDate: (payload === null || payload === void 0 ? void 0 : payload.startDate) ? firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.startDate).toDate()) : null,
                    endDate: (payload === null || payload === void 0 ? void 0 : payload.endDate) ? firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.endDate).toDate()) : null,
                    recurringDayOfWeek: payload === null || payload === void 0 ? void 0 : payload.recurringDayOfWeek,
                    recurringRepeat: payload === null || payload === void 0 ? void 0 : payload.recurringRepeat,
                    recurringType: payload === null || payload === void 0 ? void 0 : payload.recurringType,
                    occurrentDate: payload.flag === models_1.TaskFlag.urgent || payload.type !== models_1.TaskType.adHoc
                        ? payload.occurrentDate
                            ? firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.occurrentDate).toDate())
                            : null
                        : payload.startDate
                            ? firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.startDate).toDate())
                            : null,
                    nextOccurrent: payload.flag === models_1.TaskFlag.urgent || payload.type !== models_1.TaskType.adHoc
                        ? payload.nextOccurrent
                            ? firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.nextOccurrent).toDate())
                            : null
                        : payload.startDate
                            ? firestore_1.Timestamp.fromDate((0, moment_1.default)(payload.startDate).toDate())
                            : null,
                    updatedAt: firestore_1.Timestamp.now(),
                    updatedBy: uid,
                    updatedByDisplayName: displayName !== null && displayName !== void 0 ? displayName : '',
                };
                console.log('Update Task:', data);
                return [4 /*yield*/, (0, firestore_1.updateDoc)(taskDocRef, data)];
            case 3:
                _d.sent();
                _d.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); });
exports.deleteTask = (0, toolkit_1.createAsyncThunk)('task/delete', function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var taskDocRef, taskDoc, docData, commentDocRefs, commentDocs, attachments;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                taskDocRef = (0, firestore_1.doc)(firestore, 'companies', payload.companyID, 'tasks', payload.taskID);
                return [4 /*yield*/, (0, firestore_1.getDoc)(taskDocRef)];
            case 1:
                taskDoc = _a.sent();
                docData = __assign(__assign({}, taskDoc.data()), { taskID: taskDoc.id });
                commentDocRefs = (0, firestore_1.collection)(firestore, 'companies', payload.companyID, 'tasks', payload.taskID, 'comments');
                return [4 /*yield*/, (0, firestore_1.getDocs)(commentDocRefs)];
            case 2:
                commentDocs = _a.sent();
                attachments = [];
                if (docData && docData.images) {
                    attachments.push.apply(attachments, docData.images);
                }
                if (commentDocs.size > 0) {
                    commentDocs.docs.map(function (commentDoc) { return attachments.push.apply(attachments, commentDoc.data().attachments); });
                }
                return [4 /*yield*/, deleteImageByDownloadUrl(attachments)];
            case 3:
                _a.sent();
                return [4 /*yield*/, firebase_1.callable.recursiveDeleteTask(firebaseApp, { companyId: payload.companyID, taskId: payload.taskID })];
            case 4: return [2 /*return*/, _a.sent()];
        }
    });
}); });
var deleteImageByDownloadUrl = function (urls) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(urls.map(function (url) { return __awaiter(void 0, void 0, void 0, function () {
                    var imageRef;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!url) return [3 /*break*/, 2];
                                imageRef = (0, storage_1.ref)(storage, url);
                                return [4 /*yield*/, (0, storage_1.deleteObject)(imageRef)];
                            case 1: return [2 /*return*/, _a.sent()];
                            case 2: return [2 /*return*/, ''];
                        }
                    });
                }); }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var uploadImages = function (images, companyId, taskId) { return __awaiter(void 0, void 0, void 0, function () {
    var taskStorageRef, imageURI;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                taskStorageRef = (0, storage_1.ref)(storage, "companies/".concat(companyId, "/tasks"));
                return [4 /*yield*/, Promise.all(images.map(function (rawimage) { return __awaiter(void 0, void 0, void 0, function () {
                        var image, _a, fileRef, metadata;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!rawimage) return [3 /*break*/, 6];
                                    if (!(rawimage instanceof Blob)) return [3 /*break*/, 1];
                                    _a = rawimage;
                                    return [3 /*break*/, 3];
                                case 1: return [4 /*yield*/, common_1.ImageHelper.default.transformFileSize(rawimage)];
                                case 2:
                                    _a = _b.sent();
                                    _b.label = 3;
                                case 3:
                                    image = _a;
                                    fileRef = (0, storage_1.ref)(taskStorageRef, "/".concat(taskId, "/").concat((0, uuid_1.v4)(), ".jpg"));
                                    metadata = {
                                        contentType: 'image/jpeg',
                                    };
                                    return [4 /*yield*/, (0, storage_1.uploadBytes)(fileRef, image, metadata)];
                                case 4:
                                    _b.sent();
                                    return [4 /*yield*/, (0, storage_1.getDownloadURL)(fileRef)];
                                case 5: return [2 /*return*/, _b.sent()];
                                case 6: return [2 /*return*/, ''];
                            }
                        });
                    }); }))];
            case 1:
                imageURI = _a.sent();
                return [2 /*return*/, imageURI];
        }
    });
}); };
exports.updateStatus = (0, toolkit_1.createAsyncThunk)('task/updateStatus', function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var taskDocRef, taskDoc;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                taskDocRef = (0, firestore_1.doc)(firestore, 'companies', payload.companyID, 'tasks', payload.taskID);
                return [4 /*yield*/, (0, firestore_1.getDoc)(taskDocRef)];
            case 1:
                taskDoc = _b.sent();
                if (!(((_a = taskDoc.data()) === null || _a === void 0 ? void 0 : _a.status) !== payload.status)) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, firestore_1.updateDoc)(taskDocRef, {
                        status: payload.status,
                        completedBy: payload.completedBy,
                        taskCompletedAt: firestore_1.Timestamp.fromDate(new Date()),
                    })];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); });
exports.toggleSubTask = (0, toolkit_1.createAsyncThunk)('task/toggleSubTask', function (payload, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, companyID, id, taskID, isDone, taskDocRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                companyID = state.setting.activeWorkspaceID;
                id = payload.id, taskID = payload.taskID, isDone = payload.isDone;
                taskDocRef = (0, firestore_1.doc)(firestore, 'companies', companyID, 'tasks', taskID);
                return [4 /*yield*/, (0, firestore_1.updateDoc)(taskDocRef, {
                        subTaskCompleted: isDone ? (0, firestore_1.arrayRemove)(id) : (0, firestore_1.arrayUnion)(id),
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
var taskSlice = (0, toolkit_1.createSlice)({
    name: 'task',
    initialState: initialState,
    reducers: {
        setTasks: {
            reducer: function (state, action) {
                if (!action.payload)
                    state.tasks = [];
                else
                    state.tasks = action.payload;
                state.initialised = true;
            },
            prepare: function (payload) {
                if (payload) {
                    var taskModels = payload.map(function (task) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
                        return {
                            taskID: (_a = task.taskID) !== null && _a !== void 0 ? _a : '',
                            branchID: (_b = task.branchID) !== null && _b !== void 0 ? _b : '',
                            companyID: (_c = task.companyID) !== null && _c !== void 0 ? _c : '',
                            description: (_d = task.description) !== null && _d !== void 0 ? _d : '',
                            flag: task.flag === undefined ? models_1.TaskFlag.nothing : Number(task.flag),
                            images: (_e = task.images) !== null && _e !== void 0 ? _e : [],
                            name: (_f = task.name) !== null && _f !== void 0 ? _f : '',
                            status: task.status === undefined ? models_1.TaskStatus.open : Number(task.status),
                            taskCompletedAt: (task === null || task === void 0 ? void 0 : task.taskCompletedAt) instanceof firestore_1.Timestamp ? (_g = task === null || task === void 0 ? void 0 : task.taskCompletedAt) === null || _g === void 0 ? void 0 : _g.toDate().toISOString() : '',
                            type: task.type === undefined ? models_1.TaskType.daily : Number(task.type),
                            subTaskCompleted: (_h = task.subTaskCompleted) !== null && _h !== void 0 ? _h : [],
                            subTaskItems: (_j = task.subTaskItems) !== null && _j !== void 0 ? _j : [],
                            user: (_k = task.user) !== null && _k !== void 0 ? _k : [],
                            completedBy: (_l = task === null || task === void 0 ? void 0 : task.completedBy) !== null && _l !== void 0 ? _l : '',
                            startDate: (task === null || task === void 0 ? void 0 : task.startDate) instanceof firestore_1.Timestamp ? (_m = task === null || task === void 0 ? void 0 : task.startDate) === null || _m === void 0 ? void 0 : _m.toDate().toISOString() : '',
                            endDate: (task === null || task === void 0 ? void 0 : task.endDate) instanceof firestore_1.Timestamp ? (_o = task === null || task === void 0 ? void 0 : task.endDate) === null || _o === void 0 ? void 0 : _o.toDate().toISOString() : '',
                            imageSubmission: (_p = task === null || task === void 0 ? void 0 : task.imageSubmission) !== null && _p !== void 0 ? _p : false,
                            recurringDayOfWeek: (_q = task === null || task === void 0 ? void 0 : task.recurringDayOfWeek) !== null && _q !== void 0 ? _q : [],
                            recurringRepeat: (_r = task === null || task === void 0 ? void 0 : task.recurringRepeat) !== null && _r !== void 0 ? _r : null,
                            recurringType: (_s = task === null || task === void 0 ? void 0 : task.recurringType) !== null && _s !== void 0 ? _s : null,
                            occurrentDate: (task === null || task === void 0 ? void 0 : task.occurrentDate) instanceof firestore_1.Timestamp ? (_t = task === null || task === void 0 ? void 0 : task.occurrentDate) === null || _t === void 0 ? void 0 : _t.toDate().toISOString() : '',
                            nextOccurrent: (task === null || task === void 0 ? void 0 : task.nextOccurrent) instanceof firestore_1.Timestamp ? (_u = task === null || task === void 0 ? void 0 : task.nextOccurrent) === null || _u === void 0 ? void 0 : _u.toDate().toISOString() : '',
                            createdAt: task.createdAt instanceof firestore_1.Timestamp ? task.createdAt.toDate().toISOString() : '',
                            createdBy: (_v = task.createdBy) !== null && _v !== void 0 ? _v : '',
                            createdByDisplayName: (_w = task.createdByDisplayName) !== null && _w !== void 0 ? _w : '',
                            updatedAt: task.updatedAt instanceof firestore_1.Timestamp ? task.updatedAt.toDate().toISOString() : '',
                            updatedBy: (_x = task.updatedBy) !== null && _x !== void 0 ? _x : '',
                            updatedByDisplayName: (_y = task.updatedByDisplayName) !== null && _y !== void 0 ? _y : '',
                        };
                    });
                    return { payload: taskModels };
                }
                return { payload: null };
            },
        },
        setSelectedTaskID: function (state, action) {
            state.selectedTaskID = action.payload || null;
        },
        setTypeFilter: function (state, action) {
            state.typeFilter = action.payload || 0;
        },
    },
});
// Selectors
var selectTasks = function (state) { return state.task.tasks; };
exports.selectTasks = selectTasks;
exports.selectTasksByBranchID = (0, toolkit_1.createSelector)([exports.selectTasks], function (tasks) {
    return function (branchID) {
        if (!branchID) {
            return [];
        }
        return (tasks || []).filter(function (task) { return task.branchID === branchID; });
    };
});
exports.selectDailyTaskByBranchID = (0, toolkit_1.createSelector)([exports.selectTasksByBranchID], function (_selectTaskByBranchID) { return function (branchID) {
    var tasks = _selectTaskByBranchID(branchID);
    return tasks.filter(function (task) { return task.type === models_1.TaskType.daily; });
}; });
exports.selectAdhocTaskByBranchID = (0, toolkit_1.createSelector)([exports.selectTasksByBranchID], function (_selectTaskByBranchID) { return function (branchID) {
    var tasks = _selectTaskByBranchID(branchID);
    return tasks.filter(function (task) { return task.type === models_1.TaskType.adHoc; });
}; });
exports.selectCompletedTaskByBranchID = (0, toolkit_1.createSelector)([exports.selectTasksByBranchID], function (_selectTaskByBranchID) { return function (branchID) {
    var tasks = _selectTaskByBranchID(branchID);
    return tasks.filter(function (task) { return task.status === models_1.TaskStatus.closed; });
}; });
var selectSelectedTaskID = function (state) { return state.task.selectedTaskID; };
exports.selectSelectedTaskID = selectSelectedTaskID;
var selectTypeFilter = function (state) { return state.task.typeFilter; };
exports.selectTypeFilter = selectTypeFilter;
exports.selectTaskByID = (0, toolkit_1.createSelector)(exports.selectTasks, function (tasks) {
    return function callbackFunction(taskID) {
        return (tasks === null || tasks === void 0 ? void 0 : tasks.find(function (task) { return task.taskID === taskID; })) || null;
    };
});
// Actions
exports.setTasks = (_a = taskSlice.actions, _a.setTasks), exports.setSelectedTaskID = _a.setSelectedTaskID, exports.setTypeFilter = _a.setTypeFilter;
exports.default = taskSlice.reducer;
